// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button {
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  font-family: "Proxima Nova", sans-serif;
  font-size: 12px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  transition: 0.2s ease-in-out;
}
.custom-button > p {
  margin: 0;
}
.custom-button > p.has-left-icon {
  padding-left: 5px;
}
.custom-button.center {
  justify-content: center;
}
.custom-button:disabled {
  background-color: #F9F9F9 !important;
  color: #C9C9C9 !important;
  border-color: #F9F9F9 !important;
  cursor: not-allowed;
}
.custom-button.primary {
  background-color: #FAC91F;
  border-color: #FAC91F;
  color: white;
}
.custom-button.primary:hover {
  background-color: #E7B713;
  border-color: #E7B713;
}
.custom-button.primary:focus {
  background-color: #CAA00F;
  border-color: #CAA00F;
}
.custom-button.success {
  background-color: #10B980;
  border-color: #10B980;
  color: white;
}
.custom-button.success:hover {
  background-color: #139468;
  border-color: #139468;
}
.custom-button.success:focus {
  background-color: #0A6345;
  border-color: #0A6345;
}
.custom-button.reject, .custom-button.error {
  background-color: #EF4546;
  border-color: #EF4546;
  color: white;
}
.custom-button.reject:hover, .custom-button.error:hover {
  background-color: #B93535;
  border-color: #B93535;
}
.custom-button.reject:focus, .custom-button.error:focus {
  background-color: #832626;
  border-color: #832626;
}
.custom-button.dark {
  background-color: #2A2A2A;
  border-color: #2A2A2A;
  color: white;
}
.custom-button.dark:hover {
  background-color: #3a3a3a;
  border-color: #3a3a3a;
}
.custom-button.dark:focus {
  background-color: #646464;
  border-color: #646464;
}
.custom-button.light {
  background-color: white;
  border-color: white;
  color: #FAC91F;
}
.custom-button.light:hover {
  background-color: #fafafa;
  border-color: #fafafa;
}
.custom-button.light:focus {
  background-color: #f5f5f5;
  border-color: #f5f5f5;
}
.custom-button.secondary {
  background-color: white;
  color: #5F5F5F;
  border-color: #C9C9C9;
}
.custom-button.secondary:hover {
  background-color: #F9F9F9;
}
.custom-button.secondary:focus {
  background-color: #FEF7DE;
  color: #FAC91F;
  border-color: #FAC91F;
}
.custom-button.tertiary {
  background-color: #FEF7DE;
  color: #FAC91F;
  border-color: #FEF7DE;
}
.custom-button.tertiary:hover {
  background-color: #FDF1C7;
  border-color: #FDF1C7;
}
.custom-button.tertiary:focus {
  background-color: #FFECAD;
  border-color: #FFECAD;
}
.custom-button.text {
  background-color: transparent;
  color: #FAC91F;
}
.custom-button.text:hover {
  background-color: #F9F9F9;
  border-color: #F9F9F9;
}
.custom-button.text:focus {
  background-color: #F3F3F3;
  border-color: #F3F3F3;
}
.custom-button.small {
  height: 28px;
  border-radius: 6px;
  font-size: 10px;
  padding: 0 8px;
}
.custom-button.small .icon-left, .custom-button.small .icon-right {
  width: 12px;
}
.custom-button.large {
  font-size: 16px;
  height: 46px;
  padding: 0 13px;
}
.custom-button .icon-left, .custom-button .icon-right {
  width: 18px;
  display: flex;
  align-items: center;
}
.custom-button .icon-left {
  margin-right: 3px;
}
.custom-button .icon-right {
  margin-left: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomButton/customButton.scss"],"names":[],"mappings":"AAkCA;EACI,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;AAjCJ;AAkCI;EACI,SAAA;AAhCR;AAiCQ;EACI,iBAAA;AA/BZ;AAkCI;EACI,uBAAA;AAhCR;AAkCI;EACI,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAhCR;AAmCI;EACI,yBAhEK;EAiEL,qBAjEK;EAkEL,YAAA;AAjCR;AAmCQ;EACI,yBApEO;EAqEP,qBArEO;AAoCnB;AAoCQ;EACI,yBAxEO;EAyEP,qBAzEO;AAuCnB;AAsCI;EACI,yBA1DK;EA2DL,qBA3DK;EA4DL,YAAA;AApCR;AAsCQ;EACI,yBA9DO;EA+DP,qBA/DO;AA2BnB;AAuCQ;EACI,yBAlEO;EAmEP,qBAnEO;AA8BnB;AAyCI;EACI,yBA9EG;EA+EH,qBA/EG;EAgFH,YAAA;AAvCR;AAyCQ;EACI,yBAlFK;EAmFL,qBAnFK;AA4CjB;AA0CQ;EACI,yBAtFK;EAuFL,qBAvFK;AA+CjB;AA4CI;EACI,yBAtFE;EAuFF,qBAvFE;EAwFF,YAAA;AA1CR;AA4CQ;EACI,yBA1FI;EA2FJ,qBA3FI;AAiDhB;AA6CQ;EACI,yBA9FI;EA+FJ,qBA/FI;AAoDhB;AA+CI;EACI,uBAAA;EACA,mBAAA;EACA,cAlIK;AAqFb;AA+CQ;EACI,yBAAA;EACA,qBAAA;AA7CZ;AAgDQ;EACI,yBAAA;EACA,qBAAA;AA9CZ;AAkDI;EACI,uBAAA;EACA,cA1IQ;EA2IR,qBAAA;AAhDR;AAkDQ;EACI,yBAjJS;AAiGrB;AAmDQ;EACI,yBApJS;EAqJT,cApJW;EAqJX,qBArJW;AAoGvB;AAqDI;EACI,yBAvJM;EAwJN,cArJQ;EAsJR,qBAzJM;AAsGd;AAqDQ;EACI,yBA3JQ;EA4JR,qBA5JQ;AAyGpB;AAsDQ;EACI,yBA/JQ;EAgKR,qBAhKQ;AA4GpB;AAwDI;EACI,6BAAA;EACA,cAnKW;AA6GnB;AAwDQ;EACI,yBArKW;EAsKX,qBAtKW;AAgHvB;AAyDQ;EACI,yBAzKW;EA0KX,qBA1KW;AAmHvB;AA2DI;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAzDR;AA0DE;EACC,WAAA;AAxDH;AA4DI;EACI,eAAA;EACA,YAAA;EACA,eAAA;AA1DR;AA6DC;EACC,WAAA;EACM,aAAA;EACA,mBAAA;AA3DR;AA6DC;EACC,iBAAA;AA3DF;AA6DC;EACC,gBAAA;AA3DF","sourcesContent":["$primary-bg: #FAC91F;\n$primary-hover-bg: #E7B713;\n$primary-focus-bg: #CAA00F;\n\n$secondary-hover-bg: #F9F9F9;\n$secondary-focus-bg: #FEF7DE;\n$secondary-focus-text: #FAC91F;\n$secondary-text:#5F5F5F;\n\n$tertiary-bg: #FEF7DE;\n$tertiary-hover-bg: #FDF1C7;\n$tertiary-focus-bg: #FFECAD;\n$tertiary-text: #FAC91F;\n\n$text-button-text: #FAC91F;\n$text-button-hover-bg: #F9F9F9;\n$text-button-focus-bg: #F3F3F3;\n\n$error-bg: #EF4546;\n$error-hover-bg: #B93535;\n$error-focus-bg: #832626;\n\n$success-bg: #10B980;\n$success-hover-bg: #139468;\n$success-focus-bg: #0A6345;\n\n$dark-bg: #2A2A2A;\n$dark-hover-bg: #3a3a3a;\n$dark-focus-bg: #646464;\n\n$disbled-bg: #F9F9F9;\n$disbled-text: #C9C9C9;\n\n\n.custom-button {\n    border: 1px solid transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 700;\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 12px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 12px;\n    transition: .2s ease-in-out;\n    > p {\n        margin: 0;\n        &.has-left-icon {\n            padding-left: 5px;\n        }\n    }\n    &.center {\n        justify-content: center;\n    }\n    &:disabled {\n        background-color: $disbled-bg !important;\n        color: $disbled-text !important;\n        border-color: $disbled-bg !important;\n        cursor: not-allowed;\n    }\n\n    &.primary {\n        background-color: $primary-bg;\n        border-color: $primary-bg;\n        color: white;\n\n        &:hover {\n            background-color: $primary-hover-bg;\n            border-color: $primary-hover-bg;\n        }\n\n        &:focus {\n            background-color: $primary-focus-bg;\n            border-color: $primary-focus-bg;\n        }\n    }\n\n    &.success {\n        background-color: $success-bg;\n        border-color: $success-bg;\n        color: white;\n\n        &:hover {\n            background-color: $success-hover-bg;\n            border-color: $success-hover-bg;\n        }\n\n        &:focus {\n            background-color: $success-focus-bg;\n            border-color: $success-focus-bg;\n        }\n    }\n\n    &.reject, &.error {\n        background-color: $error-bg;\n        border-color: $error-bg;\n        color: white;\n\n        &:hover {\n            background-color: $error-hover-bg;\n            border-color: $error-hover-bg;\n        }\n\n        &:focus {\n            background-color: $error-focus-bg;\n            border-color: $error-focus-bg;\n        }\n    }\n\n    &.dark {\n        background-color: $dark-bg;\n        border-color: $dark-bg;\n        color: white;\n\n        &:hover {\n            background-color: $dark-hover-bg;\n            border-color: $dark-hover-bg;\n        }\n\n        &:focus {\n            background-color: $dark-focus-bg;\n            border-color: $dark-focus-bg;\n        }\n    }\n\n    &.light {\n        background-color: white;\n        border-color: white;\n        color: $primary-bg;\n\n        &:hover {\n            background-color: #fafafa;\n            border-color: #fafafa;\n        }\n\n        &:focus {\n            background-color: #f5f5f5;\n            border-color: #f5f5f5;\n        }\n    }\n\n    &.secondary {\n        background-color: white;\n        color: $secondary-text;\n        border-color: #C9C9C9;\n\n        &:hover {\n            background-color: $secondary-hover-bg;\n        }\n\n        &:focus {\n            background-color: $secondary-focus-bg;\n            color: $secondary-focus-text;\n            border-color: $secondary-focus-text;\n        }\n    }\n\n    &.tertiary {\n        background-color: $tertiary-bg;\n        color: $tertiary-text;\n        border-color: $tertiary-bg;\n\n        &:hover {\n            background-color: $tertiary-hover-bg;\n            border-color: $tertiary-hover-bg;\n        }\n\n        &:focus {\n            background-color: $tertiary-focus-bg;\n            border-color: $tertiary-focus-bg;\n        }\n    }\n\n    &.text {\n        background-color: transparent;\n        color: $text-button-text;\n\n        &:hover {\n            background-color: $text-button-hover-bg;\n            border-color: $text-button-hover-bg;\n        }\n\n        &:focus {\n            background-color: $text-button-focus-bg;\n            border-color: $text-button-focus-bg;\n        }\n    }\n\n    &.small {\n        height: 28px;\n        border-radius: 6px;\n        font-size: 10px;\n        padding: 0 8px;\n\t\t.icon-left, .icon-right {\n\t\t\twidth: 12px;\n\t\t}\n    }\n\n    &.large {\n        font-size: 16px;\n        height: 46px;\n        padding: 0 13px;\n\n    }\n\t.icon-left, .icon-right {\n\t\twidth: 18px;\n        display: flex;\n        align-items: center;\n\t}\n\t.icon-left {\n\t\tmargin-right: 3px;\n\t}\n\t.icon-right {\n\t\tmargin-left: 3px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
